import { useAppDispatch } from "@redux/hooks";
import { useEffect, useState } from "react";
import { productsApi } from "@redux/features/products/productsApi";
import { toast } from "react-toastify";

export type SerialNumberAutocompleteOption = { serial_number: string };

/**
 * Custom hook to fetch and manage serial number options for products (Receive module)
 * @param productIds Array of product IDs to fetch serial numbers for
 * @returns Object containing serial number options and loading state
 */
export function useSerialNumberOptions(productIds: number[]) {
    const dispatch = useAppDispatch();
    const [serialNumbersOptions, setSerialNumbersOptions] = useState<Record<number, SerialNumberAutocompleteOption[]>>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!productIds.length) {
            setSerialNumbersOptions({});
            return;
        }

        setIsLoading(true);

        dispatch(productsApi.endpoints.getSerialNumbersForABatchOfProducts.initiate({
            products_ids: productIds
        }))
            .unwrap()
            .then((data) => {
                const formattedOptions = data.reduce((acc, line) => {
                    if (!acc[line.product]) acc[line.product] = [];
                    acc[line.product].push(
                        ...line.values.map((v) => ({ serial_number: v }))
                    );
                    return acc;
                }, {} as Record<number, SerialNumberAutocompleteOption[]>);

                setSerialNumbersOptions(formattedOptions);
            })
            .catch((err) => {
                console.warn("Failed to load serial numbers for autocompletion!");
                toast.error(err.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [dispatch, productIds]);

    return { serialNumbersOptions, isLoading };
}


